const SearchStorageKeys = {
    "recently-viewed-vehicles": "recently-viewed-vehicles",
    usedCarsPreviousUrl: "usedCarsPreviousUrl",
    "used-cars-url-filter-history": "used-cars-url-filter-history"
};
export const setSessionStorage = (storageKey, value)=>{
    if ("object" !== "undefined") {
        window.sessionStorage.setItem(storageKey, value);
    }
};
export const getSessionStorage = (storageKey)=>{
    const storageValue = window.sessionStorage.getItem(storageKey);
    return typeof storageValue === "string" ? JSON.parse(storageValue) : {};
};
export const getUsedCarsUrlFilterHistoryFromSessionStorage = ()=>getSessionStorage("used-cars-url-filter-history");
export const setUsedCarsUrlFilterHistoryInSessionStorage = (usedCarsFilterState)=>setSessionStorage("used-cars-url-filter-history", JSON.stringify(usedCarsFilterState));
